import { useGetChatyQuery } from '@hts/shared/api';
import { IGetChatyResponse } from '@hts/shared/types';
import * as Sentry from '@sentry/react';
import { memo, useCallback, useEffect, useState } from 'react';
import WhatsAppWidget from 'react-whatsapp-chat-widget';

import 'react-whatsapp-chat-widget/index.css';
import '../styles/WhatsAppChat.scss';

type IWhatsAppChatProps = Parameters<typeof WhatsAppWidget>[0];

const defaultSettings: IWhatsAppChatProps = {
  phoneNo: '17186125052',
  position: 'right',
  widgetWidth: '300px',
  widgetWidthMobile: '260px',
  autoOpen: false,
  autoOpenTimer: 5000,
  messageBox: false,
  messageBoxTxt: '',
  iconSize: '54',
  iconColor: '#090509',
  iconBgColor: '#deb372',
  headerIcon: '/assets/images/I-hope-to-see-you-2-upd-2.png',
  headerIconColor: '#090509',
  headerTxtColor: '#090509',
  headerBgColor: '#deb372',
  headerTitle: 'Ihopetoseeyou.com',
  headerCaption: 'Online',
  bodyBgColor: '#bbb',
  chatPersonName: 'Ihopetoseeyou.com',
  chatMessage: (
    <>
      Hi there 👋 <br />
      <br /> How can we help you?
    </>
  ),
  footerBgColor: '#999',
  btnBgColor: '#deb372',
  btnTxtColor: '#090509',
};

export const WhatsAppChat = memo(() => {
  const { data: chatySettings } = useGetChatyQuery({});

  const [settings, setSettings] = useState(defaultSettings);

  const getUpdateSettings = useCallback((chatySettings: IGetChatyResponse) => {
    try {
      const updatedSettings: IWhatsAppChatProps = {
        ...defaultSettings,
        ...(chatySettings.phone && { phoneNo: chatySettings.phone }),
        ...(chatySettings.widthDesktop && { widgetWidth: `${chatySettings.widthDesktop}px` }),
        ...(chatySettings.widthMobile && { widgetWidthMobile: `${chatySettings.widthMobile}px` }),
        ...(chatySettings.iconColor && { iconColor: chatySettings.iconColor }),
        ...(chatySettings.iconBgColor && { iconBgColor: chatySettings.iconBgColor }),
        ...(chatySettings.iconHeaderColor && { headerIconColor: chatySettings.iconHeaderColor }),
        ...(chatySettings.headerTextColor && { headerTxtColor: chatySettings.headerTextColor }),
        ...(chatySettings.headerBgColor && { headerBgColor: chatySettings.headerBgColor }),
        ...(chatySettings.bodyBgColor && { bodyBgColor: chatySettings.bodyBgColor }),
        ...(chatySettings.footerBgColor && { footerBgColor: chatySettings.footerBgColor }),
        ...(chatySettings.buttonTextColor && { btnTxtColor: chatySettings.buttonTextColor }),
        ...(chatySettings.buttonBgColor && { btnBgColor: chatySettings.buttonBgColor }),
        ...(chatySettings.messageBoxText && { messageBoxTxt: chatySettings.messageBoxText }),
        ...(chatySettings.chatMessage && { chatMessage: chatySettings.chatMessage }),
      };

      return updatedSettings;
    } catch (error) {
      Sentry.captureException(error, {
        tags: { source: 'getUpdateSettings' },
        extra: { receivedData: chatySettings },
      });

      console.log(error);

      return defaultSettings;
    }
  }, []);

  useEffect(() => {
    if (!chatySettings) return;

    const newSettings = getUpdateSettings(chatySettings);

    setSettings(newSettings);
  }, [chatySettings, getUpdateSettings]);

  return <WhatsAppWidget {...settings} />;
});
